import connect from './connect';

export default connect;
